import React, { useEffect, useState } from "react";
import { Box, Modal, CircularProgress, Typography, Grid } from "@mui/material";
import DataTable from "react-data-table-component";
import ImageView from "../../../../components/imageShow";
import { toTitleCase } from "../../../../helper/helperFunction";
import styles from "./manage-user-student.module.css";
import { api } from "../../../../config/apis";

const FeedbackHistoryModal = ({ open, closeModal, studentId, row }) => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const tableColumns = [
    {
      selector: (r) => r.course_name,
      name: "Program",
      sortable: true,
    },
    {
      selector: (r) => r.section_name,
      name: "Section",
      sortable: true,
    },
    {
      selector: (r) => r.submission_period,
      name: "Submission Period",
      sortable: true,
    },
    {
      selector: "submission_date",
      cell: (r) => r.submission_date && new Date(r.submission_date).toLocaleDateString(),
      name: "Submission Date",
      sortable: true,
    },
    {
      selector: "feedback_displayed_date",
      cell: (r) => r.feedback_displayed_date && new Date(r.feedback_displayed_date).toLocaleDateString(),
      name: "Feedback Displayed Date",
      sortable: true,
    },
    {
      selector: (r) => (r.feedback_submitted ? "Submitted" : "Skipped"),
      name: "Status",
      sortable: true,
    },
    {
      selector: (r) => r.contents_align_rating,
      name: "Contents Align Rating",
      sortable: true,
    },
    {
      selector: (r) => r.materials_helpful_rating,
      name: "Materials Helpful Rating",
      sortable: true,
    },
    {
      selector: (r) => r.instructor_engagement_rating,
      name: "Instructor Engagement Rating",
      sortable: true,
    },
    {
      selector: (r) => r.explanation_clarity_rating,
      name: "Explanation Clarity Rating",
      sortable: true,
    },
    {
      selector: (r) => r.it_support_rating,
      name: "IT Support Rating",
      sortable: true,
    },
    {
      selector: (r) => r.admin_team_rating,
      name: "Admin Team Rating",
      sortable: true,
    },
    {
      selector: (r) => r.assignments_challenging ? "Yes" : "No",
      name: "Assignments Challenging",
      sortable: true,
    },
    {
      selector: (r) => r.instructor_performance,
      name: "Instructor Performance",
      sortable: false,
      wrap: true,
      minWidth: "200px",
    },
    {
      selector: (r) => r.areas_for_improvement,
      name: "Areas for Improvement",
      sortable: false,
      wrap: true,
      minWidth: "200px",
    },
    {
      selector: (r) => r.major_problems,
      name: "Major Problems",
      sortable: false,
      wrap: true,
      minWidth: "200px",
    },
  ];

  const fetchData = async () => {
    if (!studentId) return;
    setIsLoading(true);
    try {
      const res = await api.get(`admin/student-feedback-history/${studentId}`);
      const resp = res.data ?? {};
      // API returns { feedbacks: [...] }
      const feedbacks = resp.feedbacks || resp.data?.feedbacks || resp.data || [];
      setData(Array.isArray(feedbacks) ? feedbacks : []);
    } catch (err) {
      console.error("Error fetching feedback history:", err);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (open) fetchData();
  }, [open, studentId]);

  return (
    <Modal open={open} onClose={closeModal}>
      <Box className="popup" maxWidth={1000}>
        <button onClick={closeModal} className="close_btn">
          Close
        </button>
        <Box className="page-container table-phases" mt={4}>
          <Box display={"flex"} mb={2} alignItems="center">
            <h4 className={styles.history_heding}>Feedback History</h4>
            <span className={styles.image_wrap} style={{ marginLeft: 12 }}>
              <ImageView imageName={row && row.profile_image} name={row && row.name} />
              {row && toTitleCase(`${row.name || row.first_name || ""}`)}
            </span>
          </Box>

          {isLoading ? (
            <Box display="flex" justifyContent="center" mt={4}>
              <CircularProgress />
            </Box>
          ) : (
            <DataTable
              columns={tableColumns}
              data={data}
              progressPending={isLoading}
              noDataComponent={<Typography>There are no records to display</Typography>}
              highlightOnHover
              pagination={false}
            />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default FeedbackHistoryModal;
